import {OrderService, MovieService, RegionService, AuthService} from 'hasta-la-vista-middleware-api/service'

export default {

    data() {
        return {
            loading: true,
            booking: [],
            related_movies: [],
            movie: {},
            cinema: {},
            donationAmount: ''
        }
    },

    computed: {

        seatsString(){
            return this.booking.Tickets.map((t)=>t.SeatData).join(',');
        },

        bookingDate(){
            return `${this.booking.opening_date}`
        },
        movieStartTime(){
            return `${this.booking.opening_date}`
        },
        movieEndTime(){
            return 'TODO';
        }

    },
    methods: {

        getRelatedMovies(movies, user) {
            if (!user || user.isGuest() || user.PreferredGenres.length ==0){
                let m = movies.data;
                return m;
            };

            let filteredMovies = [];
            movies.data.reduce((c, movie)=> {
                movie.genres.forEach((genre)=> {
                    user.PreferredGenres.forEach((prefGen)=> {
                        if (genre.id == prefGen) {
                            filteredMovies.push(movie)
                        }
                    })
                })
            })
            return filteredMovies
        },


        downloadPDF() {
            this.generateLoader = true;
            window.open(OrderService.generateConfirmationPDF(this.$route.params.booking_number, this.$route.params.booking_id))
            this.generateLoader = false;
        },

    },
    created(){
        Promise.all([OrderService.getBooking(this.$route.params.booking_number, this.$route.params.booking_id), MovieService.getMovies(), AuthService.user()]).then(([booking,movies,user]) => {
            this.booking = booking[0];
            this.donationAmount = this.booking.Concessions[0].PriceInCents / 100;
            this.related_movies = this.getRelatedMovies(movies, user);

            Promise.all([RegionService.getCinema(this.booking.CinemaId)])
                .then(([cinema])=> {
                    this.cinema = cinema;
                    this.loading = false;
                })
        }, (error) => {
            Promise.reject(error)
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/donate/donation-successful/donation-successful.js